import { Checkbox, HStack, Input, Stack, Text, VStack } from "@chakra-ui/react";
import InputWithLabel from "../InputWithLabel";
import { useFormContext } from "react-hook-form";
import CurrencyInput from "react-currency-input-field";
import { TicketTypeValues } from "../schema";

const SingleAllocation = ({
  currency,
  loading = false,
}: {
  currency: string;
  loading?: boolean;
}) => {
  const {
    register,
    watch,
    formState: { errors, defaultValues },
    setValue,
    getValues,
  } = useFormContext<TicketTypeValues>();

  const isFree = watch("free");
  const isEdit = !!watch("id");

  const increment = watch("increment", 1);
  const incrementAboveOne = increment > 1;
  return (
    <VStack w="full" spacing={0}>
      <HStack w="full">
        <Stack w="50%">
          <InputWithLabel
            name="price"
            label={incrementAboveOne ? `Price per ticket` : `Price`}
            //@ts-ignore
            required
            renderInput={({ field, errors }) => (
              <>
                <CurrencyInput
                  //@ts-ignore
                  borderColor={errors.price ? "red" : "inherit"}
                  borderWidth={errors.price ? 2 : 1}
                  style={{ width: "100%" }}
                  disabled={field.disabled || isFree || loading}
                  placeholder={`Price`}
                  defaultValue={field.value}
                  value={field.value}
                  onValueChange={(value) => {
                    setValue(`price`, value || "", {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  }}
                  intlConfig={{
                    locale: "en-US",
                    currency,
                  }}
                  customInput={Input}
                  step={1}
                />
                {isEdit ? null : (
                  <HStack alignItems={"center"}>
                    <Text>Free</Text>
                    <Checkbox
                      {...register("free", {
                        disabled: loading,
                        onChange: (e) => {
                          const isTrue = e.target.checked;
                          if (isTrue)
                            setValue("price", undefined, {
                              shouldDirty: true,
                              shouldValidate: true,
                            });
                        },
                      })}
                    />
                  </HStack>
                )}
              </>
            )}
          />
        </Stack>

        <Stack w="50%">
          <InputWithLabel
            required
            name="limit"
            label="Limit"
            renderInput={({ field }) => (
              <Input
                name={field.name}
                required
                placeholder={"Limit"}
                isInvalid={!!errors["limit"]}
                isDisabled={field.disabled || loading}
                //@ts-ignore
                value={field.value}
                type="number"
                max={100}
                min={1}
                {...field}
              />
            )}
          >
            <Text>(Max 100)</Text>
          </InputWithLabel>
        </Stack>
      </HStack>
      <HStack w="100%">
        <HStack w="50%">
          <InputWithLabel
            required
            inputProps={{
              disabled: loading,
            }}
            name="quantity"
            label="Quantity"
            placeholder="Quantity"
          />
        </HStack>
        <HStack
          w="50%"
          height={"full"}
          justifyContent={"flex-start"}
          alignItems={"flex-start"}
        >
          <InputWithLabel
            required
            inputProps={{
              disabled: loading,
            }}
            renderInput={({ field }) => (
              <Input
                name={field.name}
                required
                placeholder={"Increment"}
                isInvalid={!!errors["increment"]}
                isDisabled={field.disabled || loading}
                //@ts-ignore
                value={field.value}
                type="number"
                max={100}
                min={1}
                {...field}
                onChange={(e) => {
                  const value = e.currentTarget.value;

                  // const pricePerTicketBefore =
                  //   parseInt(defaultValues.price) / defaultValues.increment;

                  // console.log(
                  //   getValues("price"),
                  //   value,
                  //   increment,
                  //   pricePerTicketBefore,
                  //   defaultValues.increment
                  // );

                  setValue("increment", parseInt(value), {
                    shouldDirty: true,
                    shouldTouch: true,
                  });
                }}
              />
            )}
            name="increment"
            //@ts-ignore
            defaultValue={1}
            label="Increment"
            placeholder="Increment"
          />
        </HStack>
      </HStack>
    </VStack>
  );
};

export default SingleAllocation;
